import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';

export const NewChatDialog = ({
  showNewChat,
  setShowNewChat,
  newChatData,
  setNewChatData,
  handleNewChat
}) => {
  return (
    <Dialog open={showNewChat} onOpenChange={setShowNewChat}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nueva Conversación</DialogTitle>
          <DialogDescription>
            Inicia una conversación por WhatsApp
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="telefono">Teléfono (WhatsApp) *</Label>
            <Input
              id="telefono"
              placeholder="+598 99 123 456"
              value={newChatData.telefono}
              onChange={(e) => setNewChatData({ ...newChatData, telefono: e.target.value })}
              data-testid="new-chat-phone"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="nombre">Nombre del contacto *</Label>
            <Input
              id="nombre"
              placeholder="Juan Pérez"
              value={newChatData.nombreContacto}
              onChange={(e) => setNewChatData({ ...newChatData, nombreContacto: e.target.value })}
              data-testid="new-chat-name"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="mensaje">Mensaje inicial *</Label>
            <Input
              id="mensaje"
              placeholder="Hola, me interesa..."
              value={newChatData.mensaje}
              onChange={(e) => setNewChatData({ ...newChatData, mensaje: e.target.value })}
              data-testid="new-chat-message"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setShowNewChat(false)}>
            Cancelar
          </Button>
          <Button onClick={handleNewChat} data-testid="start-chat-button">
            <Send className="h-4 w-4 mr-2" />
            Iniciar Chat
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
